import { updates } from '@/mocks/home';

const tagBg: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">吃瓜速报</h2>
            <p className="text-sm text-foreground-600">实时追踪全网最新娱乐圈爆料</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs text-foreground-500">实时更新中</span>
          </div>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>
          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div key={item.id} className="relative flex items-start gap-4 pb-5 last:pb-0 pl-12">
                <div className="absolute left-[12px] top-1.5 w-[15px] h-[15px] rounded-full border-2 border-primary-500 bg-background-50 z-10"></div>
                <span className="text-xs text-foreground-500 whitespace-nowrap mt-0.5 min-w-[70px]">{item.time}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className={`px-2 py-0.5 text-xs rounded-full font-medium whitespace-nowrap ${tagBg[item.tagColor] || tagBg.primary}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}